import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { RegistrationQuestionAnswerModel } from '../models/questions/registration-questions-answer-model';

export interface UserQuestionsState extends EntityState<RegistrationQuestionAnswerModel> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'user-questions', idKey: 'Id', cache: { ttl: 30000 } })
export class UserQuestionsStore extends EntityStore<UserQuestionsState> {
  constructor() {
    super();
  }
}
